export default __webpack_public_path__ + "static/images/app-store-badges-google3.png";